/**
 * Account settings navigation — the sections and how a URL picks one, for the
 * route's loading skeleton (the page is lazy, so the skeleton cannot import its
 * NAV_ITEMS without pulling the whole page into the main bundle). Must mirror
 * `NAV_ITEMS` / `parseSection` in pages/AccountSettings.tsx; a parity test in
 * accountSettingsLoading.test.tsx fails if they drift.
 */

export type AccountSettingsSection = 'general' | 'security' | 'notifications' | 'plans' | 'billing';

export const ACCOUNT_SETTINGS_SECTIONS: ReadonlyArray<{ id: AccountSettingsSection; label: string }> = [
  { id: 'general', label: 'General settings' },
  { id: 'security', label: 'Password and security' },
  { id: 'notifications', label: 'Notifications' },
  { id: 'plans', label: 'Plans' },
  { id: 'billing', label: 'Billing' },
];

export function parseAccountSettingsSection(raw: string | null): AccountSettingsSection {
  if (raw === 'security' || raw === 'notifications' || raw === 'plans' || raw === 'billing') {
    return raw;
  }
  return 'general';
}
